<template>
    <v-card flat width="600px">
        <v-card-title class="pa-3 headline">Add {{ this.widgetType == 0 ? "Attribute" : "Resource"}} Widget</v-card-title>

        <v-form
            ref="form"
            lazy-validation
            class="pa-3"
        >        
            <v-row class="pl-2" v-if="this.widgetType == 0">
                Select Attribute to display
            </v-row>      
            <v-select
            :items="attributes"
            :menu-props="{ maxHeight: '400' }"
            v-if="this.widgetType == 0"
            v-model="attribute"
            item-text="name"
            item-value="id"
            label="Select attribute*"
            required
            :rules="inputRules"
            ></v-select>

            <v-row class="pl-2" v-if="this.widgetType == 3">
                Select Resource type to display
            </v-row>      
            <v-select
            :items="resourceTypes"
            :menu-props="{ maxHeight: '400' }"
            v-if="this.widgetType == 3"
            v-model="resourceType"
            item-text="name"
            item-value="id"
            label="Select resource type*"
            required
            :rules="inputRules"
            ></v-select>
        </v-form>

        <v-row class="pa-3 ma-0" v-if="this.widgetType != 3">
            Add Widget Thumbnail
        </v-row>
        <v-row class="pa-3 ma-0" v-if="this.widgetType != 3">
            <v-col cols="3" class="pa-1" justify="center" align="center">
                <v-card >
                    <v-img :src='(this.files.length) ? this.files[0].thumb : ""' contain style="height:100px;width:100%"></v-img>
                </v-card>
            </v-col>
            <v-col cols="8" class="pa-1" >
                <v-card
                    class="upload"
                    color="transparent"
                    min-height="200px"
                    flat
                >
                    <v-simple-table v-if="this.files.length">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">File Name</th>
                                    <th class="text-left"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(file,index) in files" :key="file.id">
                                    <td>{{ file.name }}</td>
                                    <td>
                                        <v-btn class="icon-btn" color="red" icon @click="files.splice(index,1)">
                                            <v-icon>mdi-file-remove</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                    
                    <v-container 
                        class="fill-height pa-4"
                        fluid
                    > 
                        <v-row justify="center" align="center">
                            <v-btn width="220px">
                                <label for="file" class="btn btn-lg btn-primary" style="">
                                    Drop or Select Files
                                </label>
                            </v-btn>
                        </v-row>
                    </v-container>
                </v-card>
            </v-col>
            <file-upload
                :multiple="true"
                :drop="true"
                :drop-directory="true"
                :maximum="1"
                accept="image/*"
                @input-filter="inputFilter"
                v-model="files"
                ref="upload"
                :headers="GetAuthHeaderObj()"
            ></file-upload>
        </v-row>

        <v-row justify="center" class="pa-0 ma-0 pt-4 pb-4">
            <v-btn
                v-if="!this.widgetInCreation"
                style="width:100px"
                @click="Cancel()"
            >
                Cancel
            </v-btn>
            <v-col cols="1"></v-col>
            <v-btn
                style="width:150px"
                color="primary"
                @click="AddWidget()"
            >
                <v-icon 
                    v-if="this.widgetInCreation" 
                    size="28" 
                    color="white" dark
                >
                    mdi-loading mdi-spin
                </v-icon>
                <span v-else>Confirm</span>
            </v-btn>
        </v-row>
    </v-card>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import FileUpload from 'vue-upload-component'

export default {
    name: "AttributeWidgetTemplate",
    components: {
        FileUpload
    },
    props: {
        
        widgetType: {
         default : 0,
         type : Number   
        }
    },
    computed:{
        ...mapState("assetxpstate", [
            "section"
        ])
    },
    mounted:  function () {
        this.LoadAttributes();       
    },
    data: () => ({
        files: [],
        file : {},
        attribute: null,
        attributes: [],
        inputRules: [
            v => v !== null || 'This is a required field.',
            v => v !== '' || 'This is a required field.'
        ],
        widgetInCreation: false,
        resourceType: null,
        resourceTypes: [
            { id: 0, name: "Images" },
            { id: 1, name: "3d Objects" }
            // { id: 2, name: "Data" },
            // { id: 3, name: "Other"}
        ]
    }),
    methods:{
         ...mapGetters("authentication", [
            "CanUserEditAssets",
            "GetAuthHeaderObj"
        ]),
        ...mapActions("assetxpstate", [
            "GetSectionAttributes",
            "CreateWidget"
        ]),

        LoadAttributes() {
            this.GetSectionAttributes(this.section.id).then((response) =>{
                this.attributes = response.data;
            });
        },
        async AddWidget () {
            this.widgetInCreation = true; 

            let formData = new window.FormData();
            formData.set('sectionId', this.section.id);
            formData.set('widgetType', this.widgetType);
            formData.set('attributeId', this.attribute);
            formData.set('resourceType', this.resourceType);

            if(this.widgetType != 3) {
                for (var i = 0; i < this.$refs.upload.files.length; i++) {
                    var file = this.$refs.upload.files[i];
                    let value

                    for (let key in file.data) {
                    value = file.data[key]
                    if (value && typeof value === 'object' && typeof value.toString !== 'function') {
                        if (value instanceof File) {
                        formData.append(key, value, value.name)
                        } else {
                        formData.append(key, JSON.stringify(value))
                        }
                    } else if (value !== null && value !== undefined) {
                        formData.append(key, value)
                    }
                    }

                    formData.append(this.name, file.file, file.file.filename || file.name)
                }
            }

            this.CreateWidget(formData).then((response) =>{
                this.widgetInCreation = false;
                this.attribute = null;
                this.file = null;
                this.files = [];
                this.$emit('widgetAdded', response.data);
            });
        },
        Cancel() {
            this.$emit('hideAddDialog');
        },
        inputFilter(newFile, oldFile, prevent) {
            if (newFile && !oldFile) {
                // Before adding a file
                // Filter system files or hide files
                if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
                    return prevent()
                }

                // Filter php html js file
                if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
                    return prevent()
                }
            }

            if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
                // Create a blob field
                newFile.blob = ''
                let URL = window.URL || window.webkitURL
                
                if (URL && URL.createObjectURL) {
                    newFile.blob = URL.createObjectURL(newFile.file)
                }

                // Thumbnails
                newFile.thumb = ''
                
                if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
                    newFile.thumb = newFile.blob
                }
            }
        }
    },
    watch: {
        widgetType() {
            this.LoadAttributes();
        }
    }
}
</script> 

<style scoped> 
.v-btn {
    width: 30px;
    height: 30px;
    margin: 0px;
    padding: 0px;
}
.v-icon:hover {
    color: blue;
}
.cardContent {
    margin: 0px; 
    padding: 5px;
}
</style>